import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TypeAnimation } from 'react-type-animation';
import Button from '../Button/Button';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import './hero.css';

gsap.registerPlugin(ScrollTrigger);

const Hero = () => {
  const { t } = useTranslation();
  const [textColor, setTextColor] = useState('red');

  const dotRef = useRef(null);
  const pinWrapperRef = useRef(null);

  // ✅ 1. Track screen width
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth); // update state on resize
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // GSAP timeline for pinning and dot animation
  // useGSAP(() => {
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: pinWrapperRef.current,
  //       start: 'top top',
  //       end: '+=400%',  // total scroll length
  //       scrub: true,
  //       pin: true,
  //       anticipatePin: 1,
  //     },
  //   });
  //   if(window.innerWidth >= 760 && window.innerWidth <= 880){
  //     tl.to(dotRef.current, { x: '-93vw', duration: 1 })  // move left
  //     .to(dotRef.current, { y: '80vh', duration: 1 });  // move down
  //   }
  //    else if(window.innerWidth >= 881 && window.innerWidth < 1000){
  //     tl.to(dotRef.current, { x: '-94vw', duration: 1 })  // move left
  //     .to(dotRef.current, { y: '80vh', duration: 1 });  // move down
  //   }
  //   else if(window.innerWidth > 1024){
  //     tl.to(dotRef.current, { x: '-95vw', duration: 1 })  // move left
  //     .to(dotRef.current, { y: '80vh', duration: 1 });  // move down
  //   }
    
  // }, []);
  useGSAP(() => {
    // Clean old ScrollTrigger
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: pinWrapperRef.current,
        start: 'top top',
        end: '+=400%',
        scrub: true,
        pin: true,
        anticipatePin: 1,
      },
    });

    // ✅ 3. Responsive x value
    let xVal = '-95vw'; // default
    if (screenWidth >= 320 && screenWidth <= 343) xVal = '-96vw';
    else if (screenWidth >= 344 && screenWidth <= 439) xVal = '-89vw';
    else if (screenWidth >= 440 && screenWidth <= 539) xVal = '-89vw';
    else if (screenWidth >= 540 && screenWidth <= 640) xVal = '-91vw';
    else if (screenWidth >= 641 && screenWidth <= 759) xVal = '-92vw';
    else if (screenWidth >= 760 && screenWidth <= 880) xVal = '-93vw';
    else if (screenWidth >= 881 && screenWidth < 1020) xVal = '-94vw';
    else if (screenWidth >= 1021  && screenWidth < 1114) xVal = '-93vw';
    else if (screenWidth >= 1115  && screenWidth < 1280) xVal = '-94vw';
    else if (screenWidth >= 1281  && screenWidth < 1380) xVal = '-95vw';
    else if (screenWidth >= 1381  && screenWidth < 1480) xVal = '-96vw';
    // else if (screenWidth >= 1021) xVal = '-93vw';

    console.log(window.innerWidth)
    // ✅ 4. Animate dot
    tl.to(dotRef.current, { x: xVal, duration: 1 })
      .to(dotRef.current, { y: window.innerWidth > 640 ? '80vh' : '70vh', duration: 1 });
  }, { dependencies: [screenWidth] }); // <- this makes it run on resize too

  // GSAP animation for text elements on load
  useGSAP(() => {
    gsap.from('.heading1', {
      duration: 1.3,
      scale: 0.8,
      y: 100,
      stagger: 0.5,
      filter: 'blur(7px)',
      opacity: 0,
    });

    gsap.from('.heading2', {
      duration: 3,
      stagger: 0.5,
      filter: 'blur(7px)',
      opacity: 0,
    });

    gsap.from('.sidebox', {
      duration: 1,
      x: 500,
      stagger: 1,
      filter: 'blur(7px)',
    });
  }, []);

useEffect(() => {
  const dot = dotRef.current;
  const trailContainer = document.getElementById("dotTrailContainer");

  let lastX = 0;
  let lastY = 0;
  let lastTimestamp = performance.now();

  const updateTrail = () => {
    if (!dot || !trailContainer) return;

    const rect = dot.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const now = performance.now();

    const speed = Math.sqrt((x - lastX) ** 2 + (y - lastY) ** 2) / (now - lastTimestamp || 1);
    const trailCount = Math.min(Math.floor(speed * 100), 10);

    for (let i = 0; i < trailCount; i++) {
      const trailDot = document.createElement('div');
      trailDot.style.position = 'fixed';
      trailDot.style.left = `${x}px`;
      trailDot.style.top = `${y}px`;
      trailDot.style.border = '8px double white';
      trailDot.style.width = '45px';
      trailDot.style.height = '45px';
      trailDot.style.background = '#0000ff';
      trailDot.style.borderRadius = '50%';
      trailDot.style.opacity = `${0.2 - i * 0.02}`;
      trailDot.style.transform = 'translate(-50%, -50%)';

      trailContainer.appendChild(trailDot);

      gsap.to(trailDot, {
        opacity: 0,
        scale: 0.8,
        duration: 1,
        ease: "power1.out",
        onComplete: () => trailDot.remove()
      });
    }

    lastX = x;
    lastY = y;
    lastTimestamp = now;
  };

  gsap.ticker.add(updateTrail);

  return () => {
    gsap.ticker.remove(updateTrail);
  };
}, []);


  return (
    <div ref={pinWrapperRef} className="main-pin-wrapper  mt-0 p-0 ">
      {/* Dot & Lines Animation */}
      <div className="wrapper">
        <div className="pin-section">
          <div className="absolute bg-[#0000ff] border-2 border-white top-0 w-[96%] h-[6px] top-[16px] xxs:left-[19px]  xs:left-[24px] p-[2px]"></div>
         <div className="absolute bg-[#0000ff] border-2 border-white top-0 w-[4px] xxs:h-[70%] sm:h-[80%] top-[16px] xxs:left-[10px] xs:left-[16px] lg:left-[24px] p-[2px]"></div>

          <div className="w-[25px] h-[25px] rounded-full bg-[#0000ff] top-[8px] absolute right-[13px] z-[1] border-white border-[6px] border-double"
           ref={dotRef}></div>
           <div id="dotTrailContainer" className="absolute w-full h-full z-0 pointer-events-none"></div>

        </div>
      </div>

      {/* Hero Section */}
      <section className="min-h-[87vh]  flex  flex xs:flex-col xxs:flex-col sm:flex-row sm:items-center xs:mt-0 xxs:mt-0 sm:mt-0 text-white px-8 md:px-8  lg:px-16">
        <div className="w-full flex flex-col z-10 animate  md:ps-5 lg:ps-0">
          <h4 className="text-lg font-semibold pt-9 text-start  heading1 xl:text-2xl font-serif">{t('Hey')}</h4>
          <h1 className="xl:text-7xl lg:text-5xl heading1 sm:text-5xl xs:text-3xl font-semibold font-serif pt-0">
            {t('NameI')}  {t('NameM')}
          </h1>
          <h1 className="sm:text-5xl heading1 xs:text-3xl lg:text-7xl font-semibold font-serif">{t('NameH')}</h1>
          <h4 className="text-blue-600 heading1 mt-4 lg:text-2xl font-serif">
            <div style={{ fontSize: '25px', color: textColor }}>
              <TypeAnimation
                sequence={[
                  'Graphic Designer ',
                  800,
                  () => setTextColor('aqua'),
                  'MernStack Developer',
                  800,
                  () => setTextColor('aqua'),
                  'MernStack Developer',
                  800,
                  () => setTextColor('#faf604'),
                  'Black Hat Hacker',
                  800,
                  () => setTextColor('#2563EB'),
                  '',
                ]}
                repeat={Infinity}
              />
            </div>
          </h4>
          <p className="lg:w-[70%] heading2 font-serif text-white text-sm sm:text-base mt-2 xl:text-xl">
            {t('Experience')}
          </p>
          <div className="mt-4 flex heading2 flex-row gap-1">
            <Button Data={t('Hire')} To="/images/resume.pdf" isDownload={true} />
            <Button To={'/chat-gpt'} Data={t('ChatGpt')} />
          </div>
        </div>
<div className="w-full border border-white sm:border-none   flex sm:flex-col xs:justify-center xxs:justify-center xs:mt-4 xxs:mt-4 sm:mt-0 sm:gap-8 xs:gap-2 xxs:gap-2 xs:bg-blue-300/60 xxs:bg-blue-300/60 sm:bg-transparent p-4 rounded-lg z-10">
      <div className="flex flex-col sm:items-end sidebox xxs:items-center xs:items-center side_animate">
        <div className="inline-flex gap-1 items-center ">
          <h2 className="xl:text-8xl md:text-7xl sm:text-5xl xs:text-3xl xxs:text-2xl font-sans font-semibold">1.5</h2>
          <h2 className="text-blue-600 xl:text-8xl md:text-7xl sm:text-5xl xxs:text-2xl xs:text-3xl font-extrabold">+</h2>
        </div>
        <h4 className="xs:text-sm xxs:text-sm sm:text-base xl:text-xl xs:text-center font-serif">{t("Year")}</h4>
      </div>
      <div className="flex flex-col sm:items-end sidebox xs:items-center xxs:items-center side_animate">
        <div className="inline-flex gap-1 items-center ">
          <h2 className="xl:text-8xl md:text-7xl sm:text-5xl xs:text-3xl xxs:text-2xl font-sans font-semibold">29</h2>
          <h2 className="text-blue-600 xl:text-8xl md:text-7xl sm:text-5xl xs:text-3xl xxs:text-2xl font-extrabold ">+</h2>
        </div>
        <h4 className="xs:text-sm xxs:text-sm sm:text-base xl:text-xl xs:text-center xxs:text-center font-serif">{t("Contribution")}</h4>
      </div>
      <div className="flex flex-col sm:items-end sidebox xs:items-center xxs:items-center side_animate">
        <div className="inline-flex gap-1 items-center ">
          <h2 className="xl:text-8xl md:text-7xl sm:text-5xl xs:text-3xl xxs:text-2xl font-sans font-semibold ">40.2K</h2>
          <h2 className="text-blue-600 xl:text-8xl md:text-7xl sm:text-5xl xs:text-3xl xxs:text-2xl font-extrabold">+</h2>
        </div>
        <h4 className="xs:text-sm xxs:text-sm sm:text-base xl:text-xl xs:text-center xxs:text-center font-serif">{t("Help")}</h4>
      </div>
    </div>
      </section>
 
     

      
    </div>
  );
};

export default Hero;
